import { isNone } from '@ember/utils';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { classify } from '@ember/string';
const PREFIX = 'squareup.rolodex';
const AudienceParams = ProtoBaseModel.extend({
  type: attr(String),
  toJSON(...args) {
    const data = this._super(...args);

    // turn CHURN_RISK into squareup.rolodex.ChurnRisk
    const prefix = `${PREFIX}.${classify(data.type.toLowerCase())}`;
    for (const key in data) {
      if (key !== 'type') {
        data[`${prefix}.${key}`] = data[key];
        delete data[key];
      }
    }
    return data;
  }
});
const CasualAudienceParams = AudienceParams.extend({
  exactlyXVisits: attr(Number, {
    key: 'casual_exactly_x_visits'
  }),
  inYDays: attr(Number, {
    key: 'casual_in_y_days'
  })
});
const LoyalAudienceParams = AudienceParams.extend({
  gteXVisits: attr(Number, {
    key: 'loyal_gte_x_visits'
  }),
  inYDays: attr(Number, {
    key: 'loyal_in_y_days'
  }),
  lastVisitLtZDaysAgo: attr(Number, {
    key: 'loyal_last_visit_lt_z_days_ago'
  })
});
const ChurnRiskAudienceParams = AudienceParams.extend({
  gteXVisits: attr(Number, {
    key: 'churn_risk_gte_x_visits'
  }),
  inYDays: attr(Number, {
    key: 'churn_risk_in_y_days'
  }),
  lastVisitGtZDaysAgo: attr(Number, {
    key: 'churn_risk_last_visit_gt_z_days_ago'
  })
});
const TypeClassMap = {
  CASUAL: CasualAudienceParams,
  LOYAL: LoyalAudienceParams,
  CHURN_RISK: ChurnRiskAudienceParams
};
AudienceParams.reopenClass({
  deserialize(data) {
    if (isNone(data)) {
      return null;
    }
    // eslint-disable-next-line no-param-reassign
    data = {
      ...data
    };
    for (const key in data) {
      // key.startsWith(PREFIX)
      // grab the last part of the key
      if (key.slice(0, PREFIX.length) === PREFIX) {
        const newKey = key.split('.').pop();
        // eslint-disable-next-line no-param-reassign
        data[newKey] = data[key];
      }
    }
    const klass = !isNone(TypeClassMap[data.type]) ? TypeClassMap[data.type] : this;
    const record = klass.create({});
    // eslint-disable-next-line no-param-reassign
    data = Object.assign({}, record._data, data);
    record.load(data);
    return record;
  }
});
export default AudienceParams;